import Vue from 'vue'
import Router from 'vue-router'
import store from "../store/index";
import cookies from "vue-cookies";

// import HelloWorld from '@/components/index'
import HelloWorld from '@/components/index'
// 解决方案
import Solution from '@/components/solution/index'
import SolutionDetails from '@/components/solution/solutionDetails'
// 赋能案例
import CaseDetails from '@/components/solution/caseDetails'
// 新闻
import News from '@/components/news/index'
import NewDetails from '@/components/news/newDetails'
// 园区动态
import Park from '@/components/park/index'
// 园区详情内容
import ParkDetails from '@/components/park/parkDetails'
// 园区详情
import AllPark from '@/components/park/allPark'
// 查看更多
import ParkDynamic from '@/components/park/parkDynamic'
// vr视频
import zengcaicloudVideo from '@/components/parkSwiper/zengcaicloudVideo'
// // 设计市场-活动列表页
import activeList from '@/components/design/activeList/activeList'
// // 设计市场-活动详情
import activeDetail from '@/components/design/activeList/activeDetail'
// // 设计市场-活动详情--参赛作品详情
import worksDetails from '@/components/design/activeList/worksDetails'
// // 设计市场-活动详情--获奖作品详情
import winDetails from '@/components/design/activeList/winDetails'

// vr全景测试
import Veiws from '@/components/park/allMap/veiws'
// 测试VR
import VeiwsUrl from '@/components/park/VeiwsUrl'


// 我要打印-服务商首页
import PrintServiceIndex from '@/components/print/printServiceIndex'


import enterpriseVeiws from '@/components/park/allMap/enterpriseVeiws'
// 3D商城
import mall from '@/components/threeShop/index'
// 3D商城-商品列表
import ShopGoodsList from '@/components/threeShop/shopGoodsList'
// 3D商城-商品详情
import ShopGoodDetails from '@/components/threeShop/shopGoodDetails'
import ShopAffirmOrder from '@/components/threeShop/shopAffirmOrder'
import ShopSendSuccess from '@/components/threeShop/shopSendSuccess'
// 3D商城-商城列表
import ShopMallList from '@/components/threeShop/shopMallList'
// 3D商城-商家入驻
import ShopServiceAuthentication from '@/components/threeShop/shopServiceAuthentication'

// 商机线索
import businessSearch from '@/components/businessSearch/index'
// 商机线索列表页
import businessSearchList from '@/components/businessSearch/businessSearchList'
// 商机线索详情页
import businessSearchDetails from '@/components/businessSearch/businessSearchDetails'
// 商机活动详情页
import businessActivityDetails from '@/components/businessSearch/businessActivityDetails'

// 政务
import govInfo from '@/components/govInfo/index'
// 政务列表页
import govInfoList from '@/components/govInfo/infoList'
// 政务详情
import govInfoDetail from '@/components/govInfo/infoDetail'
// 直播列表
import govLiveList from '@/components/govInfo/liveList'
// 视频列表
import govVideoList from '@/components/govInfo/videoList'
// 播放列表
import govPlayDetail from '@/components/govInfo/playDetail'

// 软件市场
import apps from '@/components/saas/index'
// 软件超市详情页
import SaasDetails from '@/components/saas/saasDetails'
// 软件超市列表页
import SaasList from '@/components/saas/saasList'

// 注册
import Registered from '@/components/registeredLogin/registeredIndex'
// 注册成功
import RegSuccess from '@/components/registeredLogin/regSuccess'

// 登录
import Login from '@/components/registeredLogin/loginIndex'
// 登录获取code空页面
import LoginCode from '@/components/registeredLogin/LoginCode'
// 忘记密码
import forgetPassword from '@/components/registeredLogin/forgetPassword'
//
import UserCenter from '@/components/registeredLogin/userCenter/index'
// 个人中心--实名认证
import CertificationCenter from '@/components/registeredLogin/certificationCenter/index'
// 个人中心--企业认证
import EnterCertification from '@/components/registeredLogin/certificationCenter/enterCertification'
// 个人中心--企业管理
import EnterpriseCenter from '@/components/registeredLogin/enterpriseCenter/index'
// 403页面
import Undefined from '@/components/undefined'
// 在线资讯
import onlineConsult from '@/components/header/onlineConsult'
// 帮助中心
import helpCenter from '@/components/helpCenter/helpCenter'
// 帮助中心详情
import helpCenterDetail from '@/components/helpCenter/helpCenterDetail'
// 购物车
import shopCar from '@/components/threeShop/shopCar'

// 商品下架
import shelves from '@/components/shelves/shelves'

// 积分活动
import integralActivities from '@/components/integral/integralActivities'
import activeShopGoodDetails from '@/components/integral/shopGoodDetails'
import activeShopAffirmOrder from '@/components/integral/shopAffirmOrder'
import activeShopSendSuccess from '@/components/integral/shopSendSuccess'

// 集采活动
import collectActivitiesHome from '@/components/collect/collectActivitiesHome'
import collectActivities from '@/components/collect/collectActivities'
import collectShopGoodDetails from '@/components/collect/shopGoodDetails'
import collectShopAffirmOrder from '@/components/collect/shopAffirmOrder'
import collectShopSendSuccess from '@/components/collect/shopSendSuccess'

// 中心详情
import centerDetails from '@/components/centerDetails/centerDetails'
import cases from "@/components/cases/cases"

// 协会
import association from '@/components/association/index'
// 协会动态
import dynamicState from '@/components/association/dynamicState'
// 会员单位
import member from '@/components/association/member'
// 协会介绍
import introduction from '@/components/association/introduction'
// 协会新闻内容
import introductionNews from '@/components/association/components/newDetails'
// 检测服务中心 / 检测任务委托
import detectionCenterHome from '@/components/detectionEntrust/home'
import detectionEntrust from '@/components/detectionEntrust/index'

// 协会简报详情
import briefInfo from '@/components/association/components/briefInfo'

// 协会简报列表
import briefList from '@/components/association/components/briefList'

// 赋码追溯系统
import codeTraceability from '@/components/codeTraceability/index'

// 赋码追溯企业
import codeTraceabilityOther from '@/components/codeTraceabilityOther/index'
// 赋码追溯首页
import reversoContext from '@/components/reversoContext/index'

// 协会首页
import supplyHome from '@/components/supplyHome/index'
import enter from '@/components/supplyHome/components/enter' // 服务商入驻
import demandList from '@/components/supplyHome/components/list/demandList' // 需求列表
import demandDetails from '@/components/supplyHome/components/details/demandDetails' // 需求详情
import serviceList from '@/components/supplyHome/components/list/serviceList' // 服务列表
import serviceDetails from '@/components/supplyHome/components/details/serviceDetails' // 服务详情
import dynamicsList from '@/components/supplyHome/components/list/dynamicsList' // 对接案例列表
import dynamicsDetails from '@/components/supplyHome/components/details/dynamicsDetails' // 对接案例详情
import offlineList from '@/components/supplyHome/components/list/offlineList' // 线下撮合列表
import offlineDetails from '@/components/supplyHome/components/details/offlineDetails' // 线下撮合详情
import qualityServiceProviderList from '@/components/supplyHome/components/list/qualityServiceProviderList' // 优质服务商列表
import qualityServiceProviderDetails from '@/components/supplyHome/components/details/qualityServiceProviderDetails' // 优质服务商详情


import productHome from '@/components/product/index' // 产品选型首页
import productList from '@/components/product/productList' // 产品选型列表页
import specList from '@/components/product/specList' // 产品规格列表页
import newSpecList from '@/components/product/newSpecList' // 新 产品规格列表页
import productDetails from '@/components/product/productDetails' // 产品详情
import seriesDetails from '@/components/product/seriesDetails' // 系列详情
import productCompare from '@/components/product/productCompare' // 产品对比
import productOrderPage from '@/components/product/productOrderPage' // 立即下单页面
import specOrderCar from '@/components/product/specOrderCar' // 立即下单页面


import lineDetails from '@/components/supplyHome/components/list/lineDetails' // 撮合详情
import knowledgeBase from '@/components/knowledgeBase/index' // 水泵知识库
import knowledgeList from '@/components/knowledgeBase/knowledgeList' // 知识库列表
import knowledgeDetail from '@/components/knowledgeBase/knowledgeDetail' // 知识库列表-详情
import standardList from '@/components/knowledgeBase/standardList' // 标准列表

import { cookie } from 'request';

Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
}
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


let router = new Router({
    scrollBehavior: () => ({ y: 0 }),
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'home',
            // component:HelloWorld,
            component: resolve => require(['@/components/index'], resolve),
            children: [],
            meta: {
                title: '水泵云— 水泵行业综合性工业互联网平台！'
            }
        },
        {
            path: '/home',
            name: 'home',
            // component: HelloWorld,
            component: resolve => require(['@/components/index'], resolve),
            meta: {
                title: '水泵云— 水泵行业综合性工业互联网平台！'
            }
        },
        {
            path: '/solution',
            name: 'solution',
            component: Solution,
            meta: {
                title: '水泵云—解决方案'
            }
        },
        {
            path: '/caseDetails/:uuid',
            name: 'caseDetails',
            component: SolutionDetails,
            meta: {
                title: '水泵云—解决方案'
            }
        },
        {
            path: '/empowerCaseDetails/:uuid',
            name: 'empowerCaseDetails',
            component: CaseDetails,
            meta: {
                title: '水泵云—赋能案例'
            }
        },
        // cases 案列列表
        {
            path: '/cases',
            name: 'cases',
            component: cases,
            meta: {
                title: '水泵云—客户案列'
            }
        },
        {
            path: '/news',
            name: 'news',
            component: News,
            meta: {
                title: '水泵云-行业资讯'
            }
        },
        {
            path: '/news/newDetails/:uuid',
            name: 'newDetails',
            component: resolve => require(['@/components/news/newDetails'], resolve),
            meta: {
                title: '水泵云-行业资讯'
            }
        },
        {
            path: '/park',
            name: 'park',
            component: Park,
            meta: {
                title: '水泵云—泵都风采'
            }
        },
        // 中心详情
        // centerDetails
        {
            path: '/centerDetails/:uuid',
            name: 'centerDetails',
            // component: HelloWorld,
            component: centerDetails,
            meta: {
                title: '水泵云-中心详情'
            }
        },
        {
            path: '/parkDetails/:uuid',
            name: 'parkDetails',
            component: ParkDetails,
            meta: {
                title: '水泵云—泵都风采'
            }
        },
        {
            path: '/allPark/:uuid',
            name: 'allPark',
            component: AllPark,
            meta: {
                title: '水泵云—泵都风采'
            }
        },
        {
            path: '/parkDynamic/:uuid?',
            name: 'parkDynamic',
            component: ParkDynamic,
            meta: {
                title: '水泵云—泵都风采'
            }
        },
        {
            path: '/zengcaicloudVideo',
            name: 'zengcaicloudVideo',
            component: zengcaicloudVideo,
            meta: {
                title: '水泵云—共享智能铸造产业创新中心'
            }
        },
        // vr全景测试
        {
            path: '/veiws/:uuid',
            name: 'veiws',
            component: Veiws,
            // component: () => import ('@/components/park/allMap/veiws'),
            hidden: true,
            meta: {
                title: '水泵云—泵都风采'
            }
        },
        // vr全景测试
        {
            path: '/VeiwsUrl',
            name: 'VeiwsUrl',
            component: VeiwsUrl,
            hidden: true,
            meta: {
                title: '水泵云—泵都风采'
            }
        },
        // 企业VR全景
        {
            path: '/enterpriseVeiws/:uuid',
            name: 'enterpriseVeiws',
            component: enterpriseVeiws,
            // component: () => import ('@/components/park/allMap/veiws'),
            hidden: true,
            meta: {
                title: '水泵云—泵都风采'
            }
        },
        // 我要打印-服务商首页
        {
            path: '/printServiceIndex/:enterPriseId/:pageIndex?',
            name: 'printServiceIndex',
            component: PrintServiceIndex,
            meta: {
                title: '水泵云—水泵云商'
            }
        },
        // 3D商城
        {
            path: '/mall',
            name: 'mall',
            component: mall,
            meta: {
                title: '水泵云—水泵云商'
            }
        },
        // 我的购物车
        {
            path: '/shopCar',
            name: 'shopCar',
            component: shopCar,
            meta: {
                title: '水泵云—我的购物车'
            }
        },
        // 3D商城-商品列表页
        {
            path: '/shopGoodsList/:uuid?/:secondUuid?/:thirdUuid?',
            name: 'shopGoodsList',
            component: ShopGoodsList,
            meta: {
                title: '水泵云—水泵云商'
            }
        },
        // 3D商城-商品详情
        {
            path: '/shopGoodDetails/:uuid',
            name: 'shopGoodDetails',
            component: ShopGoodDetails,
            meta: {
                title: '水泵云—水泵云商'
            }
        },
        // 立即购买
        {
            path: '/shopAffirmOrder',
            name: 'shopAffirmOrder',
            component: ShopAffirmOrder,
            meta: {
                title: '水泵云-商城下单'
            }
        },
        // 购买成功
        {
            path: '/shopSendSuccess/:orderCode',
            name: 'shopSendSuccess',
            component: ShopSendSuccess,
            meta: {
                title: '水泵云-下单成功'
            }
        },
        // 3D商城-商城列表
        {
            path: '/MallList',
            name: 'shopMallList',
            component: ShopMallList,
            meta: {
                title: '水泵云—水泵云商'
            }
        },
        {
            path: '/shopServiceAuthentication',
            name: 'shopServiceAuthentication',
            component: ShopServiceAuthentication,
            meta: {
                title: '水泵云—商家入驻'
            }
        },
        // 商机线索
        {
            path: '/businessSearch',
            name: 'businessSearch',
            component: businessSearch,
            meta: {
                title: '水泵云-商机线索'
            }
        },
        // 商机线索列表页
        {
            path: '/businessSearchList',
            name: 'businessSearchList',
            component: businessSearchList,
            meta: {
                title: '水泵云-商机线索'
            }
        },
        // 商机线索详情页
        {
            path: '/businessSearchDetails/:uuid',
            name: 'businessSearchDetails',
            component: businessSearchDetails,
            hidden: true,
            meta: {
                title: '水泵云-商机线索'
            }
        },
        // 商机活动详情页
        {
            path: '/businessActivityDetails/:uuid',
            name: 'businessActivityDetails',
            component: businessActivityDetails,
            hidden: true,
            meta: {
                title: '水泵云-商机活动'
            }
        },
        // 政务信息
        {
            path: '/govInfo',
            name: 'govInfo',
            component: govInfo,
            meta: {
                title: '水泵云-政务信息'
            }
        },
        // 政务列表页
        {
            path: '/govInfoList',
            name: 'govInfoList',
            component: govInfoList,
            meta: {
                title: '水泵云-政务列表'
            }
        },
        // 政务详情
        {
            path: '/govInfoDetail',
            name: 'govInfoDetail',
            component: govInfoDetail,
            meta: {
                title: '水泵云-政务详情'
            }
        },
        // 直播列表
        {
            path: '/govLiveList',
            name: 'govLiveList',
            component: govLiveList,
            meta: {
                title: '水泵云-政务直播'
            }
        },
        // 视频列表
        {
            path: '/govVideoList',
            name: 'govVideoList',
            component: govVideoList,
            meta: {
                title: '水泵云-政务视频'
            }
        },
        // 视频列表
        {
            path: '/govPlayDetail',
            name: 'govPlayDetail',
            component: govPlayDetail,
            meta: {
                title: '水泵云-视频播放'
            }
        },
        // 软件市场
        {
            path: '/apps',
            name: 'apps',
            component: apps,
            meta: {
                title: '水泵云-应用市场'
            }
        },
        // 软件超市详情页
        {
            path: '/appsDetails/:uuid',
            name: 'saasDetails',
            component: SaasDetails,
            hidden: true,
            meta: {
                title: '水泵云-应用市场'
            }
        },
        // 软件超市列表页
        {
            // path: '/appsList/:tabParam/:search',
            path: '/appsList',
            name: 'saasList',
            component: SaasList,
            meta: {
                title: '水泵云-应用市场'
            }
        },
        // 注册
        {
            path: '/registered',
            name: 'registered',
            component: Registered,
            meta: {
                title: '水泵云-注册',
                requireAuth: true
            }
        },
        // 注册成功
        {
            path: '/regSuccess',
            name: 'regSuccess',
            component: RegSuccess,
            meta: {
                title: '水泵云-注册',
                requireAuth: true
            }
        },


        // 登录
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                title: '水泵云-登录',
                requireAuth: true
            },
        },
        // 登录跳转的空页面
        {
            path: '/loginCode',
            name: 'loginCode',
            component: LoginCode,
            meta: {
                title: '水泵云-登录',
                requireAuth: true
            },
        },
        // 忘记密码
        {
            path: '/forgetPassword',
            name: 'forgetPassword',
            component: forgetPassword,
            meta: {
                title: '水泵云-忘记密码',
                requireAuth: true
            }
        },
        // 个人中心
        {
            path: '/userCenter/:userServeId',
            name: 'userCenter',
            component: UserCenter,
            meta: {
                title: '水泵云-个人中心'
            }
        },
        // 个人中心--实名认证
        {
            path: '/certificationCenter',
            name: 'certificationCenter',
            component: CertificationCenter,
            meta: {
                title: '水泵云-个人中心'
            }
        },
        // 个人中心--企业认证
        {
            path: '/enterCertification',
            name: 'enterCertification',
            component: EnterCertification,
            meta: {
                title: '水泵云-个人中心'
            }
        },
        // 个人中心--企业管理
        {
            path: '/enterpriseCenter',
            name: 'enterpriseCenter',
            component: EnterpriseCenter,
            meta: {
                title: '水泵云-个人中心'
            }
        },
        // 403页面
        {
            path: '/undefined',
            name: 'undefined',
            component: Undefined,
            meta: {
                title: '水泵云-403页面'
            }
        },
        // 在线咨询
        {
            path: '/onlineConsult',
            name: 'onlineConsult',
            component: onlineConsult,
            meta: {
                title: '水泵云-在线咨询'
            }
        },
        // 帮助中心
        {
            path: '/helpCenter',
            name: 'helpCenter',
            component: helpCenter,
            meta: {
                title: '水泵云-帮助中心'
            }
        },
        // 帮助中心详情
        {
            path: '/helpCenterDetail',
            name: 'helpCenterDetail',
            component: helpCenterDetail,
            meta: {
                title: '水泵云-帮助中心详情页'
            }
        },
        {
            path: '/shelves',
            name: 'shelves',
            component: shelves,
            meta: {
                title: '商品下架'
            }
        },
        {
            path: '/integralActivities/:uuid',
            name: 'integralActivities',
            component: integralActivities,
            meta: {
                title: '积分活动'
            }
        },
        {
            path: '/activeShopGoodDetails',
            name: 'activeShopGoodDetails',
            component: activeShopGoodDetails,
            meta: {
                title: '积分活动商品详情'
            }
        },
        // 立即购买
        {
            path: '/activeShopAffirmOrder',
            name: 'activeShopAffirmOrder',
            component: activeShopAffirmOrder,
            meta: {
                title: '积分活动商品下单'
            }
        },
        // 购买成功
        {
            path: '/activeShopSendSuccess/:orderCode',
            name: 'activeShopSendSuccess',
            component: activeShopSendSuccess,
            meta: {
                title: '积分活动商品下单成功'
            }
        },
        {
            path: '/collectActivitiesHome',
            name: 'collectActivitiesHome',
            component: collectActivitiesHome,
            meta: {
                title: '集采活动'
            }
        },
        {
            path: '/collectActivities/:uuid',
            name: 'collectActivities',
            component: collectActivities,
            meta: {
                title: '集采活动'
            }
        },
        {
            path: '/collectShopGoodDetails',
            name: 'collectShopGoodDetails',
            component: collectShopGoodDetails,
            meta: {
                title: '集采活动商品详情'
            }
        },
        // 立即购买
        {
            path: '/collectShopAffirmOrder',
            name: 'collectShopAffirmOrder',
            component: collectShopAffirmOrder,
            meta: {
                title: '集采活动商品下单'
            }
        },
        // 购买成功
        {
            path: '/collectShopSendSuccess/:orderCode',
            name: 'collectShopSendSuccess',
            component: collectShopSendSuccess,
            meta: {
                title: '集采活动商品下单成功'
            }
        },
        // 协会首页
        {
            path: '/association',
            name: 'association',
            component: association,
            meta: {
                title: '协会首页'
            }
        },
        // 协会动态
        {
            path: '/dynamicState',
            name: 'dynamicState',
            component: dynamicState,
            meta: {
                title: '协会动态'
            }
        },
        // 会员单位
        {
            path: '/member',
            name: 'member',
            component: member,
            meta: {
                title: '会员单位'
            }
        },
        // 协会介绍
        {
            path: '/introduction',
            name: 'introduction',
            component: introduction,
            meta: {
                title: '协会介绍'
            }
        },
        // 协会介绍
        {
            path: '/introduction/introductionNews/:uuid',
            name: 'introductionNews',
            component: resolve => require(['@/components/association/components/newDetails'], resolve),
            meta: {
                title: '协会新闻'
            }
        },
        // 协会简报
        {
            path: '/brief/briefInfo/:uuid',
            name: 'briefInfo',
            component: resolve => require(['@/components/association/components/briefInfo'], resolve),
            meta: {
                title: '协会简报'
            }
        },
        // 协会简报列表
        {
            path: '/briefList',
            name: 'briefList',
            component: resolve => require(['@/components/association/components/briefList'], resolve),
            meta: {
                title: '协会简报列表'
            }
        },

        // 设计市场-活动列表页
        {
            path: '/activeList',
            name: 'activeList',
            component: activeList,
            meta: {
                title: '活动列表页'
            }
        },
        // 设计市场-活动列表页
        {
            path: '/activeDetail/:uuid?',
            name: 'activeDetail',
            component: activeDetail,
            meta: {
                title: '活动详情'
            }
        },
        // 设计市场-活动详情--参赛作品详情
        {
            path: '/worksDetails/:uuid?/:activityUuid?',
            name: 'worksDetails',
            component: worksDetails,
            meta: {
                title: '参赛作品详情'
            }
        },
        // 设计市场-活动详情--获奖作品详情
        {
            path: '/winDetails',
            name: 'winDetails',
            component: winDetails,
            meta: {
                title: '获奖作品详情'
            }
        },
        // 赋码追溯手动创建
        {
            path: '/codeTraceability',
            name: 'codeTraceability',
            component: codeTraceability,
            meta: {
                title: '水泵云-赋码追溯'
            }
        },
        // 赋码追溯系统创建
        {
            path: '/codeTraceabilityOther',
            name: 'codeTraceabilityOther',
            component: codeTraceabilityOther,
            meta: {
                title: '水泵云-赋码追溯'
            }
        },
        // 赋码追溯首页
        {
            path: '/reversoContext',
            name: 'reversoContext',
            component: reversoContext,
            meta: {
                title: '水泵云-赋码追溯'
            }
        },
        // 供需首页
        {
            path: '/supplyHome',
            name: 'supplyHome',
            component: supplyHome,
            meta: {
                title: '水泵云-供需首页'
            }
        },
        {
            path: '/enter',
            name: 'enter',
            component: enter,
            meta: {
                title: '供需-服务商入驻'
            }
        },
        {
            path: '/demandList',
            name: 'demandList',
            component: demandList,
            meta: {
                title: '供需-需求列表'
            }
        },
        {
            path: '/demandDetails',
            name: 'demandDetails',
            component: demandDetails,
            meta: {
                title: '供需-需求详情'
            }
        },
        {
            path: '/serviceList/:classifyOne?/:classifyTwo?',
            name: 'serviceList',
            component: serviceList,
            meta: {
                title: '供需-服务列表'
            }
        },
        {
            path: '/serviceDetails',
            name: 'serviceDetails',
            component: serviceDetails,
            meta: {
                title: '供需-服务详情'
            }
        },
        {
            path: '/dynamicsList',
            name: 'dynamicsList',
            component: dynamicsList,
            meta: {
                title: '供需-对接案例列表'
            }
        },
        {
            path: '/dynamicsDetails',
            name: 'dynamicsDetails',
            component: dynamicsDetails,
            meta: {
                title: '供需-对接案例详情'
            }
        },
        {
            path: '/offlineList',
            name: 'offlineList',
            component: offlineList,
            meta: {
                title: '供需-线下撮合列表'
            }
        },
        {
            path: '/offlineDetails',
            name: 'offlineDetails',
            component: offlineDetails,
            meta: {
                title: '供需-线下撮合详情'
            }
        },
        {
            path: '/qualityServiceProviderList',
            name: 'qualityServiceProviderList',
            component: qualityServiceProviderList,
            meta: {
                title: '供需-优质服务商列表'
            }
        },
        {
            path: '/qualityServiceProviderDetails/:enterPriseId',
            name: 'qualityServiceProviderDetails',
            component: qualityServiceProviderDetails,
            meta: {
                title: '供需-优质服务商详情'
            }
        },
        // 产品选型首页
        {
            path: '/productHome',
            name: 'productHome',
            component: productHome,
            children: [],
            meta: {
                title: '产品选型--首页'
            }
        },
        {
            path: '/productList',
            name: 'productList',
            component: productList,
            children: [],
            meta: {
                title: '产品选型--产品列表'
            }
        },
        {
            path: '/specList',
            name: 'specList',
            component: specList,
            children: [],
            meta: {
                title: '产品选型--规格列表'
            }
        },
        {
            path: '/newSpecList',
            name: 'newSpecList',
            component: newSpecList,
            meta: {
                title: '产品选型--规格列表'
            }
        },
        {
            path: '/productDetails',
            name: 'productDetails',
            component: productDetails,
            children: [],
            meta: {
                title: '产品选型--规格详情'
            }
        },
        {
            path: '/seriesDetails',
            name: 'seriesDetails',
            component: seriesDetails,
            children: [],
            meta: {
                title: '产品选型--产品详情'
            }
        },
        {
            path: '/productCompare',
            name: 'productCompare',
            component: productCompare,
            children: [],
            meta: {
                title: '产品选型--产品对比'
            }
        },
        {
            path: '/productOrderPage',
            name: 'productOrderPage',
            component: productOrderPage,
            children: [],
            meta: {
                title: '产品选型--经销商下单'
            }
        },
        {
            path: '/specOrderCar',
            name: 'specOrderCar',
            component: specOrderCar,
            meta: {
                title: '产品选型--经销商订货单'
            }
        },
        {
            path: '/lineDetails/:uuid',
            name: 'lineDetails',
            component: lineDetails,
            meta: {
                title: '供需-撮合详情'
            }
        },
        {
            path: '/knowledgeBase',
            name: 'knowledgeBase',
            component: knowledgeBase,
            meta: {
                title: '水泵知识库'
            }
        },
        {
            path: '/knowledgeList',
            name: 'knowledgeList',
            component: knowledgeList,
            meta: {
                title: '水泵知识库-知识库列表'
            }
        },
        {
            path: '/knowledgeDetail',
            name: 'knowledgeDetail',
            component: knowledgeDetail,
            meta: {
                title: '水泵知识库-详情'
            }
        },
        {
            path: '/standardList',
            name: 'standardList',
            component: standardList,
            meta: {
                title: '水泵知识库-标准列表'
            }
        },
        // 检测服务中心首页
        {
            path: '/detectionCenter',
            name: 'detectionCenter',
            component: detectionCenterHome,
            meta: {
                title: '水泵云-检测服务中心'
            }
        },
        // 检测任务委托
        {
            path: '/detectionEntrust',
            name: 'detectionEntrust',
            component: detectionEntrust,
            meta: {
                title: '水泵云-检测任务委托'
            }
        },

    ]
})

router.beforeEach((to, from, next) => {
    let path = to.fullPath
    console.log(path)
    // 判断该路由是否需要登录权限
    let token = cookies.get("api_token_new");
    if (to.meta.requireAuth) {
        if (token) {
            next({
                path: from.fullPath
            });
        } else {
            next()
        }
    }
    if (path != '/undefined') {
        store.commit('vuexAllPark', true)
    } else {

    }
    if (from.name == 'login' && to.name == 'printPlaceAnOrder') {
        next('/print')
    }
    store.commit('routerPathVuex', path)
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js